<script>
import RouletteWheel from "./RouletteWheel.vue";

export default {
  name: "RoulettePreviewExperience",
  components: {
    RouletteWheel
  },
  props: {
    pockets: {
      type: Array,
      required: true
    },
    rewards: {
      type: Array,
      required: true
    },
    initialBalance: {
      type: Number,
      default: 8888
    },
    depositToday: {
      type: Number,
      default: 1240
    },
    depositGoal: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      remainingSpins: 1,
      isSpinning: false,
      result: null,
      wonAmount: 0
    };
  },
  computed: {
    currentBalance() {
      return this.initialBalance + this.wonAmount;
    },
    depositProgress() {
      if (this.depositGoal <= 0) return 100;
      return Math.min(
        100,
        Math.round((this.depositToday / this.depositGoal) * 100)
      );
    },
    resultTitle() {
      return this.result && this.result.amount > 0
        ? "ค่ำคืนนี้เป็นของคุณ"
        : "เฉียดรางวัลไปนิดเดียว";
    }
  },
  methods: {
    handleSpinStart() {
      this.result = null;
      this.isSpinning = true;
    },
    handleSpinComplete(reward) {
      this.isSpinning = false;
      this.result = reward;
      this.remainingSpins = Math.max(0, this.remainingSpins - 1);
      this.wonAmount += reward.amount;
    },
    replayPreview() {
      this.result = null;
      this.remainingSpins = 1;
    }
  }
};
</script>

<template>
  <main class="roulette-preview">
    <div class="roulette-preview__grain"></div>
    <div class="roulette-preview__fan roulette-preview__fan--left"></div>
    <div class="roulette-preview__fan roulette-preview__fan--right"></div>

    <header class="preview-header">
      <div class="preview-brand">
        <div class="preview-brand__crest">
          <img src="../../assets/images/logo2.png" alt="UFAEASY 888" />
        </div>
        <div class="preview-brand__copy">
          <span>UFAEASY 888</span>
          <strong>PRIVATE SALON</strong>
        </div>
      </div>

      <div class="balance-card" aria-label="ยอดเครดิตตัวอย่าง">
        <span class="balance-card__coin">
          <img src="../../assets/images/coin.png" alt="" />
        </span>
        <span class="balance-card__copy">
          <small>เครดิตของคุณ</small>
          <strong>{{ currentBalance.toLocaleString() }}</strong>
        </span>
      </div>
    </header>

    <section class="hero-copy">
      <div class="hero-copy__eyebrow">
        <span></span>
        <p>EUROPEAN ROULETTE · PRIVATE TABLE</p>
        <span></span>
      </div>
      <h1>โต๊ะรูเล็ต <em>888</em></h1>
      <p>หมุนวงล้อ ปล่อยลูกบอล แล้วรอลุ้นรางวัลของคุณ</p>
    </section>

    <section class="eligibility-card" aria-label="สถานะสิทธิ์หมุน">
      <div class="eligibility-card__icon" aria-hidden="true">✦</div>
      <div class="eligibility-card__content">
        <div class="eligibility-card__row">
          <div>
            <small>ยอดฝากที่ร่วมรายการ</small>
            <strong>
              {{ depositToday.toLocaleString() }}
              <span>/ {{ depositGoal.toLocaleString() }}</span>
            </strong>
          </div>
          <span class="eligibility-card__status">
            <i></i>
            ได้รับสิทธิ์แล้ว
          </span>
        </div>
        <div class="eligibility-card__track">
          <span :style="{ width: `${depositProgress}%` }"></span>
        </div>
      </div>
    </section>

    <section class="table-card">
      <div class="table-card__topline">
        <p>
          <small>PRIVATE TABLE</small>
          <strong>No. 888</strong>
        </p>
        <div
          class="table-card__state"
          :class="{ 'table-card__state--active': isSpinning }"
        >
          <span></span>
          {{ isSpinning ? "กำลังหมุน" : `${remainingSpins} สิทธิ์พร้อมใช้` }}
        </div>
      </div>

      <RouletteWheel
        :pockets="pockets"
        :rewards="rewards"
        :remaining-spins="remainingSpins"
        @spin-start="handleSpinStart"
        @spin-complete="handleSpinComplete"
      />
    </section>

    <footer class="preview-footer">
      <span>PREVIEW</span>
      <p>ทดลองหน้าตาและการหมุนเท่านั้น ยังไม่มีการบันทึกรางวัลจริง</p>
    </footer>

    <transition name="result">
      <div v-if="result" class="result-overlay" role="dialog" aria-modal="true">
        <section class="result-sheet">
          <div class="result-sheet__rays"></div>
          <div class="result-sheet__seal">
            <span>{{ result.amount > 0 ? "✦" : "888" }}</span>
          </div>
          <p class="result-sheet__eyebrow">RESULT · PRIVATE TABLE 888</p>
          <h2>{{ resultTitle }}</h2>
          <p class="result-sheet__description">
            {{
              result.amount > 0
                ? `ลูกบอลลงที่หมายเลข ${result.pocketNumber}`
                : "พรุ่งนี้กลับมาลุ้นกันใหม่นะ"
            }}
          </p>

          <div
            class="result-sheet__reward"
            :class="{ 'result-sheet__reward--empty': result.amount === 0 }"
          >
            <img
              v-if="result.amount > 0"
              src="../../assets/images/coin.png"
              alt=""
            />
            <strong v-if="result.amount > 0">+{{ result.amount }}</strong>
            <strong v-else>GOOD LUCK</strong>
            <span>{{ result.amount > 0 ? "เครดิต" : "NEXT TIME" }}</span>
          </div>

          <p class="result-sheet__note">
            Preview เท่านั้น — ไม่มีการเพิ่มเครดิตหรือบันทึกผลจริง
          </p>
          <button type="button" @click="replayPreview">ลองหมุนอีกครั้ง</button>
        </section>
      </div>
    </transition>
  </main>
</template>

<style lang="scss" scoped>
.roulette-preview {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  max-width: 480px;
  overflow: hidden;
  margin: 0 auto;
  padding: calc(14px + env(safe-area-inset-top, 0px)) clamp(14px, 4vw, 22px)
    calc(24px + env(safe-area-inset-bottom, 0px));
  background: radial-gradient(
      circle at 50% 46%,
      rgba(151, 52, 39, 0.31),
      transparent 31%
    ),
    radial-gradient(
      ellipse at 105% 24%,
      rgba(211, 155, 79, 0.16),
      transparent 42%
    ),
    radial-gradient(
      ellipse at -5% 85%,
      rgba(148, 42, 32, 0.18),
      transparent 38%
    ),
    linear-gradient(158deg, #10231d 0%, #0b1915 48%, #050c0a 100%);
  color: #f7ead2;
  font-family: "Athiti", "Kanit", sans-serif;
  isolation: isolate;
}

.roulette-preview::before {
  content: "";
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(
      60deg,
      transparent 49.7%,
      rgba(225, 186, 120, 0.055) 50%,
      transparent 50.3%
    ),
    linear-gradient(
      -60deg,
      transparent 49.7%,
      rgba(225, 186, 120, 0.04) 50%,
      transparent 50.3%
    ),
    radial-gradient(
      circle at 18% 12%,
      rgba(255, 232, 176, 0.62) 0 1px,
      transparent 2px
    ),
    radial-gradient(
      circle at 82% 18%,
      rgba(216, 164, 89, 0.5) 0 1px,
      transparent 2px
    );
  background-size: 82px 142px, 82px 142px, 160px 190px, 190px 230px;
  opacity: 0.7;
}

.roulette-preview::after {
  content: "";
  position: absolute;
  z-index: 0;
  right: -250px;
  bottom: 17%;
  width: 500px;
  height: 180px;
  border: 1px solid rgba(220, 174, 103, 0.22);
  border-radius: 50%;
  pointer-events: none;
  transform: rotate(-16deg);
  box-shadow: 0 0 0 8px rgba(213, 160, 82, 0.025),
    0 0 0 24px rgba(213, 160, 82, 0.018);
}

.roulette-preview__grain {
  position: fixed;
  z-index: 30;
  inset: 0;
  pointer-events: none;
  opacity: 0.035;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.86' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='.72'/%3E%3C/svg%3E");
}

.roulette-preview__fan {
  position: absolute;
  z-index: 0;
  width: 150px;
  height: 150px;
  border: 1px solid rgba(222, 178, 111, 0.12);
  border-radius: 50%;
  pointer-events: none;
}

.roulette-preview__fan::before,
.roulette-preview__fan::after {
  content: "";
  position: absolute;
  inset: 17%;
  border: 1px solid rgba(222, 178, 111, 0.1);
  border-radius: 50%;
}

.roulette-preview__fan::after {
  inset: 35%;
}

.roulette-preview__fan--left {
  top: 23%;
  left: -112px;
}

.roulette-preview__fan--right {
  right: -122px;
  bottom: 8%;
}

.preview-header {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.preview-brand {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.preview-brand__crest {
  display: grid;
  width: 44px;
  height: 44px;
  overflow: hidden;
  border: 1px solid rgba(235, 200, 137, 0.56);
  border-radius: 11px;
  place-items: center;
  background: #070b09;
  box-shadow: inset 0 0 0 3px rgba(214, 160, 80, 0.08),
    0 7px 18px rgba(0, 0, 0, 0.32);
}

.preview-brand__crest img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.preview-brand__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  line-height: 1.08;
}

.preview-brand__copy span {
  color: #f4dfba;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.preview-brand__copy strong {
  margin-top: 4px;
  color: rgba(232, 204, 153, 0.62);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 8px;
  letter-spacing: 0.2em;
}

.balance-card {
  display: flex;
  min-width: 126px;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  padding: 7px 12px 7px 8px;
  border: 1px solid rgba(225, 184, 115, 0.24);
  border-radius: 13px;
  background: linear-gradient(
    135deg,
    rgba(245, 225, 185, 0.1),
    rgba(6, 15, 12, 0.42)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 8px 20px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.balance-card__coin {
  display: grid;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  place-items: center;
  background: rgba(193, 124, 47, 0.15);
  box-shadow: 0 0 14px rgba(222, 159, 71, 0.15);
}

.balance-card__coin img {
  width: 25px;
  height: 25px;
}

.balance-card__copy {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.balance-card__copy small {
  color: rgba(241, 225, 195, 0.58);
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.03em;
}

.balance-card__copy strong {
  color: #f7dc9d;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
}

.hero-copy {
  position: relative;
  z-index: 3;
  margin-top: clamp(18px, 5.6vw, 27px);
  text-align: center;
}

.hero-copy__eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.hero-copy__eyebrow span {
  width: 27px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(225, 183, 112, 0.72));
}

.hero-copy__eyebrow span:last-child {
  transform: rotate(180deg);
}

.hero-copy__eyebrow p {
  margin: 0;
  color: rgba(232, 202, 149, 0.66);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.17em;
}

.hero-copy h1 {
  margin: 8px 0 3px;
  color: #fff2d7;
  font-family: "Mali", "Kanit", sans-serif;
  font-size: clamp(29px, 8.2vw, 39px);
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: -0.035em;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.32);
}

.hero-copy h1 em {
  color: #dfb76d;
  font-style: normal;
}

.hero-copy > p {
  margin: 0;
  color: rgba(242, 226, 196, 0.64);
  font-size: clamp(12px, 3.5vw, 14px);
  font-weight: 500;
}

.eligibility-card {
  position: relative;
  z-index: 4;
  display: flex;
  margin-top: clamp(15px, 4vw, 20px);
  padding: 10px 12px;
  border: 1px solid rgba(225, 183, 112, 0.19);
  border-radius: 15px;
  align-items: center;
  gap: 11px;
  background: linear-gradient(
    115deg,
    rgba(241, 218, 173, 0.095),
    rgba(4, 11, 9, 0.34)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 10px 28px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.eligibility-card__icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border: 1px solid rgba(232, 190, 116, 0.38);
  border-radius: 10px;
  place-items: center;
  background: rgba(171, 50, 39, 0.18);
  color: #f3ce8b;
  box-shadow: inset 0 0 14px rgba(184, 64, 48, 0.18);
}

.eligibility-card__content {
  min-width: 0;
  flex: 1;
}

.eligibility-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.eligibility-card__row > div {
  display: flex;
  flex-direction: column;
  line-height: 1.05;
}

.eligibility-card__row small {
  color: rgba(240, 222, 188, 0.56);
  font-size: 9px;
}

.eligibility-card__row strong {
  margin-top: 4px;
  color: #f5d899;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
}

.eligibility-card__row strong span {
  color: rgba(237, 216, 178, 0.42);
  font-size: 9px;
  font-weight: 500;
}

.eligibility-card__status {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #b9e4cd;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.eligibility-card__status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #62c799;
  box-shadow: 0 0 8px rgba(98, 199, 153, 0.7);
}

.eligibility-card__track {
  height: 3px;
  overflow: hidden;
  margin-top: 8px;
  border-radius: 999px;
  background: rgba(238, 220, 183, 0.1);
}

.eligibility-card__track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #a4372e, #e5b86d);
  box-shadow: 0 0 8px rgba(222, 167, 85, 0.46);
}

.table-card {
  position: relative;
  z-index: 3;
  margin-top: clamp(11px, 3vw, 16px);
  padding: 11px 8px 12px;
  border: 1px solid rgba(224, 179, 105, 0.16);
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(226, 190, 129, 0.07),
    rgba(5, 13, 10, 0.18) 34%,
    rgba(4, 10, 8, 0.4)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04),
    0 24px 50px rgba(0, 0, 0, 0.2);
}

.table-card__topline {
  display: flex;
  padding: 0 8px 8px;
  align-items: center;
  justify-content: space-between;
}

.table-card__topline p {
  display: flex;
  margin: 0;
  align-items: baseline;
  gap: 7px;
}

.table-card__topline small {
  color: rgba(231, 204, 158, 0.46);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.table-card__topline strong {
  color: #efd091;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 12px;
}

.table-card__state {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(239, 222, 192, 0.62);
  font-size: 10px;
  font-weight: 600;
}

.table-card__state span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #67c797;
  box-shadow: 0 0 8px rgba(103, 199, 151, 0.64);
}

.table-card__state--active span {
  background: #e2ad5f;
  box-shadow: 0 0 8px rgba(226, 173, 95, 0.72);
  animation: statePulse 0.8s ease-in-out infinite alternate;
}

.preview-footer {
  position: relative;
  z-index: 3;
  display: flex;
  margin-top: 12px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: rgba(235, 216, 180, 0.45);
  text-align: center;
}

.preview-footer span {
  padding: 3px 7px;
  border: 1px solid rgba(225, 182, 111, 0.22);
  border-radius: 999px;
  color: rgba(235, 198, 137, 0.72);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.preview-footer p {
  margin: 0;
  font-size: 9px;
}

.result-overlay {
  position: fixed;
  z-index: 10020;
  inset: 0;
  display: flex;
  padding: 20px;
  align-items: flex-end;
  justify-content: center;
  background: rgba(1, 7, 5, 0.76);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.result-sheet {
  position: relative;
  width: min(100%, 430px);
  overflow: hidden;
  padding: 31px 24px calc(22px + env(safe-area-inset-bottom, 0px));
  border: 1px solid rgba(239, 203, 139, 0.44);
  border-radius: 28px 28px 18px 18px;
  background: radial-gradient(
      circle at 50% 6%,
      rgba(188, 62, 48, 0.34),
      transparent 35%
    ),
    linear-gradient(155deg, #183329, #0b1814 62%, #060d0b);
  box-shadow: 0 -18px 60px rgba(0, 0, 0, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.07);
  text-align: center;
}

.result-sheet__rays {
  position: absolute;
  top: -118px;
  left: 50%;
  width: 330px;
  height: 330px;
  border: 1px solid rgba(230, 189, 119, 0.1);
  border-radius: 50%;
  transform: translateX(-50%);
  background: repeating-conic-gradient(
    from 0deg,
    rgba(231, 191, 119, 0.06) 0deg 3deg,
    transparent 3deg 15deg
  );
  animation: rayTurn 24s linear infinite;
}

.result-sheet__seal {
  position: relative;
  display: grid;
  width: 62px;
  height: 62px;
  margin: 0 auto 13px;
  border: 1px solid #e7bd75;
  border-radius: 50%;
  place-items: center;
  background: radial-gradient(circle, #f5d894, #bc7938 60%, #5d3115);
  color: #4b2511;
  box-shadow: 0 0 0 4px #713c1b, 0 0 0 6px rgba(238, 201, 132, 0.56),
    0 8px 22px rgba(0, 0, 0, 0.38);
}

.result-sheet__seal span {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 22px;
  font-weight: 700;
}

.result-sheet__eyebrow {
  position: relative;
  margin: 0 0 6px;
  color: rgba(229, 188, 116, 0.66);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.result-sheet h2 {
  position: relative;
  margin: 0;
  color: #fff0d1;
  font-family: "Mali", "Kanit", sans-serif;
  font-size: 25px;
  font-weight: 600;
}

.result-sheet__description {
  position: relative;
  margin: 5px 0 0;
  color: rgba(244, 228, 198, 0.62);
  font-size: 13px;
}

.result-sheet__reward {
  position: relative;
  display: flex;
  width: fit-content;
  margin: 21px auto 17px;
  padding: 9px 21px 10px;
  border: 1px solid rgba(232, 190, 116, 0.33);
  border-radius: 16px;
  align-items: center;
  gap: 8px;
  background: rgba(237, 205, 145, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.result-sheet__reward img {
  width: 35px;
  height: 35px;
}

.result-sheet__reward strong {
  color: #f6d58f;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 31px;
  line-height: 1;
}

.result-sheet__reward span {
  align-self: flex-end;
  padding-bottom: 2px;
  color: rgba(242, 221, 182, 0.6);
  font-size: 12px;
  font-weight: 600;
}

.result-sheet__reward--empty {
  flex-direction: column;
  gap: 2px;
}

.result-sheet__reward--empty strong {
  font-size: 21px;
  letter-spacing: 0.06em;
}

.result-sheet__reward--empty span {
  align-self: center;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 8px;
  letter-spacing: 0.16em;
}

.result-sheet__note {
  position: relative;
  margin: 0 0 14px;
  color: rgba(238, 218, 181, 0.4);
  font-size: 10px;
}

.result-sheet button {
  position: relative;
  width: 100%;
  padding: 13px 20px;
  border: 1px solid #e4b868;
  border-radius: 14px;
  background: linear-gradient(135deg, #f2d28f, #c9853e 55%, #a85e29);
  color: #341c0e;
  font-family: "Mali", "Kanit", sans-serif;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
}

.result-enter-active,
.result-leave-active {
  transition: opacity 280ms ease;
}

.result-enter-active .result-sheet,
.result-leave-active .result-sheet {
  transition: transform 420ms cubic-bezier(0.2, 0.78, 0.2, 1);
}

.result-enter,
.result-leave-to {
  opacity: 0;
}

.result-enter .result-sheet,
.result-leave-to .result-sheet {
  transform: translateY(40px) scale(0.97);
}

@keyframes statePulse {
  from {
    opacity: 0.48;
  }
  to {
    opacity: 1;
  }
}

@keyframes rayTurn {
  to {
    transform: translateX(-50%) rotate(360deg);
  }
}

@media (max-height: 720px) {
  .hero-copy {
    margin-top: 12px;
  }

  .hero-copy h1 {
    margin-top: 5px;
    font-size: 27px;
  }

  .eligibility-card {
    margin-top: 10px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .table-card {
    margin-top: 8px;
  }

  .preview-footer {
    margin-top: 8px;
  }
}

@media (min-width: 600px) {
  .roulette-preview {
    min-height: calc(100vh - 32px);
    margin-top: 16px;
    margin-bottom: 16px;
    border: 1px solid rgba(228, 185, 116, 0.2);
    border-radius: 30px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.42);
  }
}

@media (prefers-reduced-motion: reduce) {
  .table-card__state--active span,
  .result-sheet__rays {
    animation: none;
  }

  .result-enter-active,
  .result-leave-active,
  .result-enter-active .result-sheet,
  .result-leave-active .result-sheet {
    transition-duration: 1ms;
  }
}
</style>
